



















import Vue from 'vue';
import type { Location } from 'vue-router';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import HeaderMenuOutsider from '~/components/global/HeaderMenu/HeaderMenuOutsider.vue';
import { ONBOARDING_V3_EXPECTATIONS_PAGE, LINK_TO_MOBILE_APP } from '~/constants';

export default Vue.extend({
  name: 'HeaderOutsider',
  components: {
    HeaderMenuOutsider,
    BravadoButtonV3,
  },
  computed: {
    linkToMobileApp(): string {
      return LINK_TO_MOBILE_APP;
    },
    onboardingPage(): Location {
      return ONBOARDING_V3_EXPECTATIONS_PAGE;
    },
  },
});
